import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, CheckCircle, XCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  const { email } = useParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const unsubscribe = async () => {
      try {
        const response = await axios.get(`${API}/mailing-list/unsubscribe/${encodeURIComponent(email)}`);
        setMessage(response.data.message);
        setStatus('success');
      } catch (error) {
        setMessage('Something went wrong. Please try again or contact us.');
        setStatus('error');
      }
    };

    if (email) {
      unsubscribe();
    } else {
      setMessage('Invalid unsubscribe link.');
      setStatus('error');
    }
  }, [email]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-zinc-900 border border-zinc-800 p-8 text-center">
        <h1 className="font-mono text-2xl text-tiffany-500 tracking-wider mb-2">BLK MRKT</h1>
        <p className="font-mono text-xs text-zinc-500 tracking-widest mb-8">BLK LIST</p>

        {status === 'loading' && (
          <div className="py-8">
            <Mail className="w-12 h-12 text-zinc-500 mx-auto mb-4 animate-pulse" />
            <p className="font-mono text-zinc-400 tracking-wide">PROCESSING YOUR REQUEST...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="py-8">
            <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
            <p className="font-mono text-white mb-2 tracking-wide">{message}</p>
            <p className="font-mono text-sm text-zinc-500 mt-4 tracking-wide">
              CHANGED YOUR MIND? YOU CAN ALWAYS RE-SUBSCRIBE ON OUR WEBSITE.
            </p>
          </div>
        )}

        {status === 'error' && (
          <div className="py-8">
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <p className="font-mono text-white mb-2 tracking-wide">{message}</p>
          </div>
        )}

        <Link 
          to="/" 
          className="font-mono text-tiffany-500 text-sm hover:underline mt-6 inline-block tracking-widest"
        >
          RETURN TO SHOP
        </Link>
      </div>
    </div>
  );
}
